import {useDispatch, useSelector} from "react-redux";
import {ACTION_TYPE} from "utils/constants";
import Container from "./Container";
import {useState} from "react";

export default function OOBCEditor(props) {
  const asset = useSelector(state => state.asset);
  const {userData} = asset.scenes[asset.selectedSceneName];
  const dispatch = useDispatch();
  const [varNumber, setVarNumber] = useState(0);

  const getPrototypeBlocksInfo = () => {
    return {
      sceneIds: [asset.selectedSceneName],
      gameObjects: getGameObjectPrototypeBlocks(),
      variables: getVariablesBlocks(),
      strings: [],
    };
  };

  const getGameObjectPrototypeBlocks = () => {
    const gameObjects = [
      {
        name: "main_character",
        uuid: "0",
        animationIds: ["walk", "idle", "die", "victory", "jump"],
      },
    ];

    const currentScene = asset.scenes[asset.selectedSceneName];
    currentScene.traverse(obj => {
      if (obj.userData.isSprite === true && obj.userData.canScript === true) {
        let newObj = {};
        newObj.uuid = obj.uuid;
        newObj.name = obj.name;
        gameObjects.push(newObj);
      }
    });
    // return gameObjects;
    const guiScene = asset.scenes["GUI"];
    guiScene.traverse(obj => {
      if (obj.userData.isSprite === true && obj.userData.canScript === true) {
        let newObj = {};
        newObj.uuid = obj.uuid;
        newObj.name = obj.name;
        gameObjects.push(newObj);
      }
    });
    return gameObjects;
  };

  const getVariablesBlocks = () => {
    const currentScene = asset.scenes["default"];
    if (!currentScene) return;
    return currentScene.userData.oobcGlobalVariables || [];
  };

  const changeScript = (code, json) => {
    dispatch({type: ACTION_TYPE.CHANGE_SCRIPT, payload: {code, json}});
  };

  const onAddGlobalVar = name => {
    const variables = asset.scenes["default"]?.userData?.oobcGlobalVariables;
    if (!variables) asset.scenes["default"].userData.oobcGlobalVariables = [];
    asset.scenes["default"].userData.oobcGlobalVariables.push(name);

    const num = varNumber;
    setVarNumber(num + 1);
  };

  return (
    <Container
      {...props}
      prototypesInfo={getPrototypeBlocksInfo()}
      changeScript={changeScript}
      onAddGlobalVar={onAddGlobalVar}
      varNumber={varNumber}
      userData={userData}
    />
  );
}
